export default __webpack_public_path__ + "static/david-sima-93d46de8083a8a5f5125cefe9c22f85e.svg";